import React, { useState } from 'react';
import './OpeningStockModal.css';

const OpeningStockModal = ({ product, locations, onClose, onSave }) => {
  const [openingStockRows, setOpeningStockRows] = useState([
    {
      id: Date.now(),
      qty: '',
      cost: '',
      date: new Date().toISOString().split('T')[0],
      note: ''
    }
  ]);

  const [selectedLocation, setSelectedLocation] = useState(locations[0]?.id || '');

  const handleAddRow = () => {
    setOpeningStockRows(prev => [
      ...prev,
      {
        id: Date.now(),
        qty: '',
        cost: '',
        date: new Date().toISOString().split('T')[0],
        note: ''
      }
    ]);
  };

  const handleRemoveRow = (id) => {
    if (openingStockRows.length > 1) {
      setOpeningStockRows(prev => prev.filter(row => row.id !== id));
    }
  };

  const handleChange = (id, field, value) => {
    setOpeningStockRows(prev => prev.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  const handleSave = () => {
    const data = {
      productId: product.id,
      locationId: selectedLocation,
      stockData: openingStockRows
    };
    onSave(data);
    onClose();
  };

  const totalAmount = openingStockRows.reduce((sum, row) => {
    const qty = parseFloat(row.qty) || 0;
    const cost = parseFloat(row.cost) || 0;
    return sum + (qty * cost);
  }, 0);

  if (!product) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-container opening-stock-modal" 
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '1100px', width: '95%' }}
      >
        <div className="modal-header">
          <h2>Add or edit Opening Stock</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="modal-content" style={{ width: '100%', maxWidth: 'none' }}>
          <div style={{ marginBottom: '1.5rem', display: 'flex', gap: '2rem', alignItems: 'center' }}>
            <div style={{ fontSize: '0.95rem', fontWeight: '500' }}>
              Product: <span style={{ color: 'var(--etpos-primary, #3b82f6)' }}>{product.name}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <label style={{ fontWeight: '600', fontSize: '0.9rem' }}>Business Location:</label>
              <select 
                value={selectedLocation} 
                onChange={(e) => setSelectedLocation(e.target.value)}
                style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #e2e8f0' }}
              >
                {locations.map(loc => (
                  <option key={loc.id} value={loc.id}>{loc.name}</option>
                ))}
              </select>
            </div>
          </div>

          <table className="opening-stock-table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ minWidth: '150px' }}>Product Name</th>
                <th style={{ minWidth: '160px' }}>Quantity Remaining</th>
                <th style={{ minWidth: '150px' }}>Unit Cost (Before Tax)</th>
                <th style={{ minWidth: '130px', textAlign: 'center' }}>Subtotal (Before Tax)</th>
                <th style={{ minWidth: '150px' }}>Date</th>
                <th style={{ minWidth: '200px' }}>Note</th>
                <th style={{ width: '50px', textAlign: 'center' }}></th>
              </tr>
            </thead>
            <tbody>
              {openingStockRows.map((row, idx) => {
                const subtotal = (parseFloat(row.qty) || 0) * (parseFloat(row.cost) || 0);
                return (
                  <tr key={row.id}>
                    <td>{product.name}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <input
                          type="number"
                          value={row.qty}
                          placeholder="0.00"
                          onChange={(e) => handleChange(row.id, 'qty', e.target.value)}
                        />
                        <span style={{ display: 'flex', alignItems: 'center', color: '#64748b' }}>
                          {product.unit || 'Unit'}
                        </span>
                      </div>
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        value={row.cost}
                        placeholder="0.00"
                        onChange={(e) => handleChange(row.id, 'cost', e.target.value)}
                      />
                    </td>
                    <td style={{ textAlign: 'center', fontWeight: '600' }}>
                      {subtotal.toFixed(2)}
                    </td>
                    <td>
                      <input
                        type="date"
                        value={row.date}
                        onChange={(e) => handleChange(row.id, 'date', e.target.value)}
                      />
                    </td>
                    <td>
                      <textarea
                        value={row.note}
                        rows="1"
                        onChange={(e) => handleChange(row.id, 'note', e.target.value)}
                        style={{ resize: 'vertical' }}
                      />
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {idx === 0 ? (
                        <button className="action-btn-add" onClick={handleAddRow}>+</button>
                      ) : (
                        <button className="action-btn-remove" onClick={() => handleRemoveRow(row.id)}>✕</button>
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr className="opening-stock-total-row">
                <td colSpan={3} style={{ textAlign: 'right' }}>Total Amount (Exc. Tax):</td>
                <td style={{ textAlign: 'center' }}>{totalAmount.toFixed(2)}</td>
                <td colSpan={3}></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="modal-footer">
          <button className="modal-btn primary" onClick={handleSave}>Save</button>
          <button className="modal-btn secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default OpeningStockModal;
